import { useContext } from "react";
import { ConfigContext } from './Provider';
var useEnv = function () {
    return useContext(ConfigContext);
};
export default useEnv;
//# sourceMappingURL=useClientEnv.js.map